import React from 'react';
import { Marker, Popup } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import useStyles from './Finding.styles';
import { Icon } from '../../../common/components/icons';
import findingTypeEnum from '../../../finding/models/findingTypeEnum';
import { IconButton } from '../../../common/components/buttons';
import { Image } from '../../../common/components/images';
import { formatDate } from '../../../common/formatters/timeFormatters';
import { FindingShape } from '../../../finding/models/Finding';
import { useFindingContext } from '../../../finding/contexts/findingContext';
import priorityEnum from '../../../finding/models/priorityEnum';

const Finding = ({ patrolId, finding, coordinates, visible }) => {
  const classes = useStyles({ creationMode: finding.creationMode });

  const { clickedFinding, setClickedFinding } = useFindingContext();

  const isCurrentFinding = clickedFinding && clickedFinding.id === finding.id;

  const handleIconButtonClick = () => setClickedFinding(finding);

  const handlePopupClose = () => setClickedFinding(undefined);

  if (!visible) return null;

  return (
    <div>
      <Marker coordinates={coordinates} anchor="center">
        <IconButton onClick={handleIconButtonClick}>
          {finding.type === findingTypeEnum.threat && finding.priority === priorityEnum.investigation && (
            <Icon icon="error" className={classes.investigateIcon} />
          )}
          {finding.type === findingTypeEnum.threat && finding.priority === priorityEnum.immediate && <Icon icon="warning" className={classes.immediateIcon} />}
          {finding.type === findingTypeEnum.note && <Icon icon="edit" className={classes.noteIcon} />}
          {finding.type === findingTypeEnum.dismissed && <Icon icon="cancel" className={classes.dismissedIcon} />}
          {finding.type === findingTypeEnum.unclassified && <Icon icon="help" className={classes.unclassifiedIcon} />}
        </IconButton>
      </Marker>

      {isCurrentFinding && (
        <Popup coordinates={coordinates} onClick={handlePopupClose} style={{ zIndex: 4 }} anchor="center">
          <div className={classes.popupContent}>
            <div className={classes.findingImageContainer}>
              <Image useGeneric={finding.overriden} patrolId={patrolId} finding={finding} />
            </div>
            <div className={classes.label}>{finding.label}</div>
            <div className={classes.sentAt}>{`${i18n.t('patrol.finding.sent')}: ${formatDate(finding.acknowledgedAt, finding.timezone)}`}</div>
          </div>
        </Popup>
      )}
    </div>
  );
};

Finding.propTypes = {
  patrolId: PropTypes.number.isRequired,
  finding: FindingShape.isRequired,
  coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
  visible: PropTypes.bool,
};

Finding.defaultProps = {
  visible: true,
};

export default React.memo(Finding);
